import formModel from './formModel';

const {
    firstName,
    lastName,
    email,
    contactNumber,
    companyName,
    role,
    roleOther,
    dietaryRequirements,
    dietaryOther,
} = formModel;

const initialValues = {
    [firstName.name]: '',
    [lastName.name]: '',
    [email.name]: '',
    [contactNumber.name]: '',
    [companyName.name]: '',
    [role.name]: '',
    [roleOther.name]: '',
    [dietaryRequirements.name]: '',
    [dietaryOther.name]: '',
};

export default initialValues;
